import React from 'react';
import * as _ from 'lodash';
import moment from 'moment';

import Tippy, { ToolTip } from '../ReactTippy';
import Information from './common/Information';
import { VerticalScrollBodyTable } from '../tables/VerticalScrollBodyTable';
import InfinityScrollLoad from '../InfinityScrollLoad';
import { WorkScheduleService } from '../../services/Works';
import { messageUtility } from '../../utilities/messageUtility';
import { DATE_TIME_FORMAT } from '../../utilities/constants';

/**
 * check in not reflect works dialog in work result
 * @props {number}fieldId
 * @props {string}fromDate
 * @props {string}toDate
 * @props {string}onClose
 */
class CheckInNotReflectWorksDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      isListLoading: true,
      total: 0,
    };
    this.bodyId = _.uniqueId('infinity-scroll-target');

    this.headerColumns = [
      { id: 'target_date', text: '日付', style: { width: 80 } },
      { id: 'company_name', text: '会社名' },
      { id: 'reflect_works_total', text: '入場人数', style: { width: 90 } },
    ];

    this.bodyColumns = [
      {
        id: 'target_date',
        render: data => {
          return moment(data.target_date).format(
            DATE_TIME_FORMAT.slashDateFormatNoYear
          );
        },
        style: { width: 80 },
        useTooltip: false,
      },
      {
        id: 'company_name',
        render: data => {
          const { company_name, company_name_1, nest_no } = data;
          const isShowCompanyNameLevel1 = nest_no !== 1;

          const companyNameTooltip = isShowCompanyNameLevel1 ? (
            <React.Fragment>
              {company_name_1}
              <br />（{company_name}）
            </React.Fragment>
          ) : (
            company_name_1
          );
          return (
            <Tippy
              duration={10}
              distance={24}
              arrowType='sharp'
              delay={[500, 0]}
              placement='bottom'
              followCursor={true}
              html={<ToolTip>{companyNameTooltip}</ToolTip>}
            >
              <div className='data-table__company-name'>
                <React.Fragment>
                  <span className='data-table__text-wrap data-table__text-wrap--overflow'>
                    {company_name_1}
                  </span>
                  {isShowCompanyNameLevel1 && (
                    <span className='data-table__text-wrap data-table__text-wrap--overflow'>
                      （{company_name}）
                    </span>
                  )}
                </React.Fragment>
              </div>
            </Tippy>
          );
        },
      },
      {
        id: 'reflect_works_total',
        render: data => `${data.reflect_works_total}人`,
        style: { width: 90 },
        useTooltip: false,
      },
    ];
  }

  componentDidMount() {
    this.loadItems();
  }

  loadItems = () => {
    const { items, total } = this.state;
    if (!_.isEmpty(items) && _.size(items) >= total) {
      return;
    }

    this.setState(
      {
        isListLoading: true,
      },
      () => {
        const { fieldId, fromDate, toDate } = this.props;
        WorkScheduleService.getNotReflectWorks(fieldId, {
          date_from: fromDate,
          date_to: toDate,
          limit: 30,
          offset: _.size(items),
        })
          .then(response => {
            if (!response.result) {
              return;
            }
            this.setState({
              items: items.concat(
                _.get(response, 'data.entities.unreflect_works')
              ),
              total: _.get(response, 'data.total'),
            });
          })
          .finally(() => {
            this.setState({
              isListLoading: false,
            });
          });
      }
    );
  };

  getTable = () => {
    return (
      <React.Fragment>
        <VerticalScrollBodyTable
          headerColumns={this.headerColumns}
          bodyColumns={this.bodyColumns}
          tableClassName='CheckInNotReflectWorkTable'
          bodyId={this.bodyId}
          data={this.state.items}
          allowEmptyData={false}
          bodyFooter={
            <tr className='infinity-scroll-load-item'>
              <td colSpan={3}>
                <InfinityScrollLoad
                  total={this.state.total}
                  targetId={this.bodyId}
                  callback={this.loadItems}
                  isLoading={this.state.isListLoading}
                  ignoreIndicator={true}
                />
              </td>
            </tr>
          }
        />
      </React.Fragment>
    );
  };

  render() {
    return (
      <Information
        title={messageUtility.getMessage('I-000-187')}
        visible={true}
        message={this.getTable()}
        buttonText={messageUtility.getMessage('I-000-008')}
        onClose={() => {
          _.isFunction(this.props.onClose) && this.props.onClose();
        }}
        multilineText={true}
      />
    );
  }
}

export default CheckInNotReflectWorksDialog;



// WEBPACK FOOTER //
// ./src/components/modals/CheckInNotReflectWorksDialog.js